webpackJsonp([221374088121123],{

/***/ 92:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(5);
	
	var emptyObject = __webpack_require__(32);
	var _invariant = __webpack_require__(1);
	
	if (false) {
	  var warning = require('fbjs/lib/warning');
	}
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillMount`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillReceiveProps`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillUpdate`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillUpdate: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Similar to ReactClassInterface but for static methods.
	   */
	  var ReactClassStaticInterface = {
	    /**
	     * This method is invoked after a component is instantiated and when it
	     * receives new props. Return an object to update state in response to
	     * prop changes. Return null to indicate no change to state.
	     *
	     * If an object is returned, its keys will be merged into the existing state.
	     *
	     * @return {object || null}
	     * @optional
	     */
	    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isAlreadyDefined = name in Constructor;
	      if (isAlreadyDefined) {
	        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
	          ? ReactClassStaticInterface[name]
	          : null;
	
	        _invariant(
	          specPolicy === 'DEFINE_MANY_MERGED',
	          'ReactClass: You are attempting to define ' +
	            '`%s` on your component more than once. This conflict may be ' +
	            'due to a mixin.',
	          name
	        );
	
	        Constructor[name] = createMergedResultFunction(Constructor[name], property);
	
	        return;
	      }
	
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
	        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
	          'Did you mean UNSAFE_componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ }),

/***/ 5:
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),

/***/ 281:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 195:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(4);
	__webpack_require__(281);
	
	var BeforeAndAfter = function (_React$Component) {
	    _inherits(BeforeAndAfter, _React$Component);
	
	    function BeforeAndAfter() {
	        _classCallCheck(this, BeforeAndAfter);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	
	        _this.state = { after: _this.props.percent || 50 };
	        return _this;
	    }
	
	    BeforeAndAfter.prototype.render = function render() {
	        var _this2 = this;
	
	        return React.createElement("div", { id: "before-and-after" }, React.createElement("figure", { style: { backgroundImage: "url(" + this.props.before + ")" } }, React.createElement("div", { id: "after", style: {
	                width: this.state.after + "%",
	                backgroundImage: "url(" + this.props.after + ")"
	            } })), React.createElement("input", { type: "range", min: "0", max: "100", value: this.state.after, id: "slider", onChange: function onChange(e) {
	                _this2.setState({ after: Number(e.target.value) });
	            } }));
	    };
	
	    return BeforeAndAfter;
	}(React.Component);
	
	exports.BeforeAndAfter = BeforeAndAfter;

/***/ }),

/***/ 196:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(4);
	var Links_1 = __webpack_require__(67);
	exports.ThankYou = function () {
	    return React.createElement("div", { className: "footer" }, React.createElement(Links_1.Credit, { phrase: "Made by", children: "Devon Zuegel", link: "twitter.com/devonzuegel" }), React.createElement("span", { className: "separator" }, "\u2022"), "Renderings by", ' ', React.createElement(Links_1.ExternalLink, { children: "Flora Bao", link: "www.aiasf.org/members/?id=39131857" }), ' ', "& ", React.createElement(Links_1.ExternalLink, { children: "UVIZ", link: "www.uvizstudio.com" }), React.createElement("span", { className: "separator" }, "\u2022"), "Thanks to ", React.createElement(Links_1.ExternalLink, { children: "Nat Friedman", link: "twitter.com/natfriedman" }), ", ", React.createElement(Links_1.ExternalLink, { children: "Louis Mirante", link: "twitter.com/louismirante" }), ", & ", React.createElement(Links_1.ExternalLink, { children: "Hunter Owens", link: "twitter.com/hunter_owens" }));
	};
	exports.AboutProject = function () {
	    return React.createElement("div", { className: "section" }, React.createElement("h2", null, "About this project"), React.createElement("p", null, "This site was originally published on April 2, 2018. You can find the source and revision history", ' ', React.createElement(Links_1.ExternalLink, { link: "github.com/devonzuegel/sb827" }, "here"), "."));
	};

/***/ }),

/***/ 197:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(4);
	var Links_1 = __webpack_require__(67);
	exports.Introduction = function () {
	    return React.createElement("div", { className: "two-columns" }, React.createElement("p", null, "California is in a housing crisis. For a sense of its scale:"), React.createElement("ul", null, React.createElement("li", null, "In 2017, California added roughly", ' ', React.createElement(Links_1.ExternalLink, { link: "www.dof.ca.gov/Forecasting/Demographics/Estimates/E-5/" }, "one home for every four people"), ' ', "who came to the state, and this pattern has held for decades."), React.createElement("li", null, "54% of renter households and 39% of mortgage holders paid over", ' ', React.createElement(Links_1.ExternalLink, { link: "calbudgetcenter.org/resources/californians-parts-state-pay-can-afford-housing" }, "30% of their income toward housing"), ' ', "in 2015.")), React.createElement("p", null, "We're ", React.createElement("i", null, "lucky"), " that people want to move here. Newcomers want to participate in the opportunities available in our state, but a shortage of places to live makes it hard for them to make those contributions."), React.createElement("p", null, "This is not a new problem, but for the first time there's a proposal facing the state legislature that could make a dent: Senate Bill 827 (", React.createElement(Links_1.ExternalLink, { link: "leginfo.legislature.ca.gov/faces/billTextClient.xhtml?bill_id=201720180SB827" }, "SB 827"), "). The bill would change zoning around transit to allow for mid-rise housing."), React.createElement("p", null, "I've seen countless scary-sounding headlines like \"", React.createElement("a", { target: "_blank", rel: "nofollow", href: "http://padailypost.com/2018/02/18/housing-bill-result-85-foot-tall-buildings-el-camino" }, "Housing bill could result in 85-foot tall buildings on El Camino"), "\". I totally understand where these fears come from\u2014I grew up around there, and it's frightening to think about how the places I love might change."), React.createElement("p", null, "However, when I dug into the numbers, not only were my fears alleviated but I actually got really excited. Rather than the community-destroying godzilla it's been made out to be, SB 827 will make neighborhoods far more vibrant, eco-friendly, and equitable."), React.createElement("p", null, "To get an intuitive sense of what SB 827 would make possible, some friends and I created renderings to illustrate its potential. We picked a few vacant but promising lots located near transit throughout the state. In a few years they could be a new home for some friendly new neighbors. Use the sliders below to see what they could become!"));
	};

/***/ }),

/***/ 67:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(4);
	exports.ExternalLink = function (props) {
	    return React.createElement("a", { target: "_blank", href: "http://" + props.link }, props.children);
	};
	exports.Credit = function (props) {
	    return React.createElement("span", null, props.phrase, " ", React.createElement(exports.ExternalLink, _extends({}, props)));
	};

/***/ }),

/***/ 282:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 198:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(4);
	__webpack_require__(282);
	var Map = function Map(props) {
	    return React.createElement("iframe", { className: "place-info--map", src: props.src, allowFullScreen: true });
	};
	var Downloads = function Downloads(props) {
	    return React.createElement("div", { className: "place-info--downloads" }, React.createElement("b", null, "Downloads:"), React.createElement("a", { href: props.before, download: true }, "before"), React.createElement("span", { className: "place-info--separator" }, "\u2022"), React.createElement("a", { href: props.after, download: true }, "after"));
	};
	var Impact = function Impact(props) {
	    return React.createElement("div", null, props.impacts.map(function (_ref, k) {
	        var name = _ref[0],
	            value = _ref[1];
	        return React.createElement("div", { key: k }, React.createElement("b", null, name, ":"), " ", value);
	    }));
	};
	exports.PlaceInfo = function (props) {
	    return React.createElement("div", { className: "place-info" }, React.createElement("div", { className: "place-info--left" }, React.createElement(Map, _extends({}, props)), React.createElement(Impact, _extends({}, props)), React.createElement(Downloads, _extends({}, props))), React.createElement("div", { className: "place-info--description" }, React.createElement("h2", null, props.emphasis), props.description.map(function (paragraph, i) {
	        return React.createElement("p", { key: i }, paragraph);
	    })));
	};

/***/ }),

/***/ 419:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/1-after.af5e5702.jpg";

/***/ }),

/***/ 420:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/1-before.d79c9859.jpg";

/***/ }),

/***/ 421:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/2-after.8a1d3f0a.jpg";

/***/ }),

/***/ 422:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/2-before.463c71b0.jpg";

/***/ }),

/***/ 423:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/3-after.cca696e9.jpg";

/***/ }),

/***/ 424:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/3-before.87b430c0.jpg";

/***/ }),

/***/ 425:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/4-after.24229623.jpg";

/***/ }),

/***/ 426:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/4-before.e3ee3c00.jpg";

/***/ }),

/***/ 427:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/5-after-B.1562916f.jpg";

/***/ }),

/***/ 428:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/5-before.1bce3906.jpg";

/***/ }),

/***/ 429:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/6-after.16efbc1d.jpg";

/***/ }),

/***/ 430:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/6-before.69ae2492.jpg";

/***/ }),

/***/ 431:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/8-after.4700b6d2.jpg";

/***/ }),

/***/ 432:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/8-before.aa96b971.jpg";

/***/ }),

/***/ 433:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/1-after.2631c5cf.jpg";

/***/ }),

/***/ 434:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/1-before.a4ccf8cb.jpg";

/***/ }),

/***/ 435:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/2-after.b883be94.jpg";

/***/ }),

/***/ 436:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/2-before.b595939e.jpg";

/***/ }),

/***/ 437:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/3-after.64f38339.jpg";

/***/ }),

/***/ 438:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/3-before.52ca5f2a.jpg";

/***/ }),

/***/ 439:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/4-after.e67411ce.jpg";

/***/ }),

/***/ 440:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/4-before.ea3cf3d8.jpg";

/***/ }),

/***/ 441:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/5-after-B.d10aca69.jpg";

/***/ }),

/***/ 442:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/5-before.05146a12.jpg";

/***/ }),

/***/ 443:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/6-after.16efbc1d.jpg";

/***/ }),

/***/ 444:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/6-before.300a12c6.jpg";

/***/ }),

/***/ 445:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/8-after.350f0b89.jpg";

/***/ }),

/***/ 446:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/8-before.d4b155fb.jpg";

/***/ }),

/***/ 201:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(4);
	var BeforeAndAfter_1 = __webpack_require__(195);
	var PlaceInfo_1 = __webpack_require__(198);
	var Links_1 = __webpack_require__(67);
	var Introduction_1 = __webpack_require__(197);
	var Footer_1 = __webpack_require__(196);
	// Renders
	var Render01Before = __webpack_require__(420);
	var Render01After = __webpack_require__(419);
	var Render02Before = __webpack_require__(422);
	var Render02After = __webpack_require__(421);
	var Render03Before = __webpack_require__(424);
	var Render03After = __webpack_require__(423);
	var Render04Before = __webpack_require__(426);
	var Render04After = __webpack_require__(425);
	var Render05Before = __webpack_require__(428);
	var Render05After = __webpack_require__(427);
	var Render06Before = __webpack_require__(430);
	var Render06After = __webpack_require__(429);
	var Render08Before = __webpack_require__(432);
	var Render08After = __webpack_require__(431);
	// Downloads
	var Render01Before_FullSize = __webpack_require__(434);
	var Render01After_FullSize = __webpack_require__(433);
	var Render02Before_FullSize = __webpack_require__(436);
	var Render02After_FullSize = __webpack_require__(435);
	var Render03Before_FullSize = __webpack_require__(438);
	var Render03After_FullSize = __webpack_require__(437);
	var Render04Before_FullSize = __webpack_require__(440);
	var Render04After_FullSize = __webpack_require__(439);
	var Render05Before_FullSize = __webpack_require__(442);
	var Render05After_FullSize = __webpack_require__(441);
	var Render06Before_FullSize = __webpack_require__(444);
	var Render06After_FullSize = __webpack_require__(443);
	var Render08Before_FullSize = __webpack_require__(446);
	var Render08After_FullSize = __webpack_require__(445);
	
	var default_1 = function (_React$Component) {
	    _inherits(default_1, _React$Component);
	
	    function default_1() {
	        _classCallCheck(this, default_1);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	    }
	
	    default_1.prototype.render = function render() {
	        return React.createElement("div", null, React.createElement("div", { className: "section" }, React.createElement("h1", null, "What would SB 827 mean for California?"), React.createElement(Introduction_1.Introduction, null)), React.createElement(BeforeAndAfter_1.BeforeAndAfter, { before: Render08Before, after: Render08After, percent: 70 }), React.createElement(PlaceInfo_1.PlaceInfo, { before: Render08Before_FullSize, after: Render08After_FullSize, emphasis: "SB 827 means an affordable place to live could exist on every block", description: ['Most places in California have effectively legislated that the housing supply remain fixed. Meanwhile, demand skyrockets. These restrictions take the form of low-density zoning, which puts a tiny cap on the number of people who can participate in the community. People are then forced to compete for what limited housing is available, which pushes prices up.', "The status quo disproportionately hurts the disadvantaged. Our current policy is making the state less diverse, displacing minorities and vibrant, edgy experimenters by pushing up rents to levels that only white collar professionals can afford to pay.", React.createElement("p", null, "This shortage doesn't only hurt the people who want to move here. In reducing overall mobility, it stagnates the economy for everyone.", ' ', React.createElement(Links_1.ExternalLink, { link: "faculty.chicagobooth.edu/chang-tai.hsieh/research/growth.pdf" }, "Economists estimate"), ' ', "that land-use restrictions reduced U.S. GDP as a whole by roughly 9% each year since the 1960s. (Even if we assume that's an order of magnitude off, at 0.9% per year, that compounds to a doubling of the economy that we missed out on!)"), "SB 827 would do away with a lot of these arbitrary regulations that restrict where people can live. It would allow supply to begin to respond to demand, bringing us an important step closer to reining in the absurd cost of living in California."], src: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d840.1963474816608!2d-117.084435970752!3d32.61190229881392!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80d94dd41d76dcf9%3A0xf2c2045a19309578!2s1041+Jefferson+Ave%2C+Chula+Vista%2C+CA+91911!5e0!3m2!1sen!2sus!4v1522210849364", address: ['1041 Jefferson Ave', 'Chula Vista, CA 91911'], impacts: [['Number of units', '51'], ['Occupancy', '102-126']] }), React.createElement(BeforeAndAfter_1.BeforeAndAfter, { before: Render06Before, after: Render06After, percent: 65 }), React.createElement(PlaceInfo_1.PlaceInfo, { before: Render06Before_FullSize, after: Render06After_FullSize, emphasis: "SB 827 means that parents can spend more time with their kids rather than commuting in their cars", description: [React.createElement("p", null, "Housing prices in cities have risen faster than wages, pushing people ever further from their jobs. The result is tedious commutes,", ' ', React.createElement("a", { href: "https://www.sfgate.com/bayarea/article/These-have-been-judged-the-Bay-Area-s-10-worst-12207607.php" }, "traffic congestion"), ", and lost productivity. About", ' ', React.createElement("a", { href: "https://www.nytimes.com/2018/03/16/business/energy-environment/climate-density.html" }, "1 in 20"), ' ', "Bay Area commuters spends more than 90 minutes traveling to work, and that number is rising. That time would be better spent doing literally anything else, but we've given these workers little choice. Workers are forced to make a tradeoff\u2014spend all of their time commuting, or spend all of their savings on housing close to work. Many people are", ' ', React.createElement("a", { href: "http://www.sacbee.com/news/state/california/article136478098.html" }, "opting out all together"), ", moving out to settle down in more affordable regions."), React.createElement("p", null, "This is not the natural ebb and flow of supply and demand. We have imposed an artificial shortage on housing similar to", ' ', React.createElement("a", { href: "https://courses.lumenlearning.com/boundless-economics/chapter/impacts-of-monopoly-on-efficiency/" }, "monopoly pricing"), ' ', "that results in deadweight loss. Current rules allow people who already have access to all California has to offer to exclude others from those same opportunities. This massively disadvantages the large number of people who are excluded at only a slight short-term advantage to the people who are already here."), "Californians pride themselves on welcoming newcomers, but this is a hollow ideal if we don't create places for them to live. SB 827 would alleviate this artificial restriction, and its focus around transit would minimize any additional strain on our infrastructure.  It would allow more people to contribute to California's thriving economy, which is good for everyone."], src: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d391.7260048928203!2d-122.6330726!3d38.2375615!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8085b6aa0d6a5c49%3A0x4477696a140294f4!2s310+Wilson+St%2C+Petaluma%2C+CA+94952!5e0!3m2!1sen!2sus!4v1522212099560", address: ['310 Wilson St', 'Petaluma, CA 94952'], impacts: [['Number of units', '3'], ['Occupancy', '6-10']] }), React.createElement(BeforeAndAfter_1.BeforeAndAfter, { before: Render05Before, after: Render05After, percent: 70 }), React.createElement(PlaceInfo_1.PlaceInfo, { before: Render05Before_FullSize, after: Render05After_FullSize, emphasis: "SB 827 means that we can reduce our carbon footprint", description: ["To achieve California's environmental goals, we need to revisit local zoning laws. These restrictions mandate low-density housing around transit, which limits the number of people who can use it, induces sprawl, and pushes people to drive more.", React.createElement("p", null, "If people can live near transit, they'll be able drive less. This is a big deal\u201440 percent of California's carbon emissions are from transportation, so making a dent in this number is key to reducing our overall environmental impact. A", ' ', React.createElement("a", { href: "https://uli.bookstore.ipgbook.com/growing-cooler-products-9780874201789.php" }, "study from the Urban Land Institute"), ' ', "found that policies to promote compact growth\u2014like SB 827\u2014could cut vehicle travel by 40 percent."), React.createElement("p", null, "\"It'll give us a much better chance of meeting our climate goals,\"", ' ', React.createElement("a", { href: "https://www.curbed.com/2018/1/24/16928438/sb827-california-housing-crisis-senator-scott-wiener" }, "said"), ' ', "Senator Scott Weiner, who proposed the bill. \"We'll never meet them with our current land-use patterns.\"")], src: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d793.1359663801818!2d-121.9107603!3d37.329631!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x808fcb5cf5d99191%3A0x989323c608a07f0c!2s1030+Garland+Ave%2C+San+Jose%2C+CA+95126!5e0!3m2!1sen!2sus!4v1522212783283", address: ['1030 Garland Ave', 'San Jose, CA'], impacts: [['Number of units', '17'], ['Occupancy', '18-24']] }), React.createElement("br", null), React.createElement(BeforeAndAfter_1.BeforeAndAfter, { before: Render01Before, after: Render01After, percent: 65 }), React.createElement(PlaceInfo_1.PlaceInfo, { before: Render01Before_FullSize, after: Render01After_FullSize, emphasis: "SB 827 means we can make full use of our infrastructure investments", description: ["We make massive investments in California's transit infrastructure, but they go underutilized. The core of the problem is that local zoning rules restrict the number of people this infrastructure can serve.", "When a neighborhood reaps the benefits of regional and statewide projects, their development plans should reflect the resources that the broader community has funneled their way. I sympathize with the desire for local control, but it's unfair and inefficient for a place to reap the benefits of investment by the broader California community if they don't respond in kind by welcoming neighbors that infrastructure was intended to serve. It just doesn't make sense to spend millions of dollars on a new transit hub surrounded by low-density sprawl.", "SB 827 would go far in righting this imbalance. The bill would cut some of the red tape around building around transit, enabling us to make the most of our transit investments."], src: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3149.4015937269373!2d-122.28537068400891!3d37.874289979741434!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80857ebe90b946ef%3A0xfee56f2e56062794!2sNorth+Berkeley+BART+Station!5e0!3m2!1sen!2sus!4v1523441743704", address: ['North Berkeley BART Station', 'Berkeley, CA 94702'], impacts: [] }), React.createElement("br", null), React.createElement(BeforeAndAfter_1.BeforeAndAfter, { before: Render02Before, after: Render02After, percent: 75 }), React.createElement(PlaceInfo_1.PlaceInfo, { before: Render02Before_FullSize, after: Render02After_FullSize, emphasis: "SB 827 means vibrant, beautiful neighborhoods", description: [React.createElement("p", null, "A concern I hear a lot is that this bill could damage neighborhood character due to overcrowding, ugly condos, and so on. Again, I sympathize with this fear. As a Bay Area native, San Francisco's unique charm holds a special place for me, and I don't want the Painted Ladies to be replaced with a massive condo."), React.createElement("p", null, "Fortunately, housing people and building beautiful neighborhoods are not mutually exclusive. In fact, they complement one another!"), React.createElement("p", null, "Paris, perhaps the most beloved city in the world, is a good illustration. It's gorgeous and does not feel overcrowded, so most people are shocked to learn that Paris has higher population density than New York City. A big part of what people love about the city is just how accessible everything is, which is only possible when there's a critical mass of people to support an abundance of shops, cafes, and transit. They manage to do this even while working with an 8 story limit throughout most of the city! Paris simultaneously supports a dense population and is one of the most livable cities in the world. We can do that in California, too, without sacrficing what we love about our communities.")], src: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1583.822307709984!2d-122.16515714167554!3d37.44549939495518!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x808fbb376fa3b65d%3A0x88ae6a53d8c99c7!2sLytton+Ave+%26+Emerson+St%2C+Palo+Alto%2C+CA+94301%2C+USA!5e0!3m2!1sen!2snl!4v1523830882066", address: ['Downtown Palo Alto'], impacts: [['Number of units', '69'], ['Occupancy', '106']] }), React.createElement("br", null), React.createElement(BeforeAndAfter_1.BeforeAndAfter, { before: Render03Before, after: Render03After, percent: 60 }), React.createElement(PlaceInfo_1.PlaceInfo, { before: Render03Before_FullSize, after: Render03After_FullSize, emphasis: "Where can I learn more about SB 827?", description: [React.createElement("p", null, "Here are a few pointers to get started learning more about California land use and how SB 827 would impact the state:"), React.createElement("ul", null, React.createElement("li", null, "To see how the bill affects your district, you can go to:", ' ', React.createElement("a", { href: "https://sb827.info/" }, "sb827.info"), " for detailed map and fact sheet."), React.createElement("li", null, React.createElement("a", { href: "https://transitrichhousing.org/" }, "Visualize Transit-Rich Housing: What would SB 827 really look like?"), ' ', "is the most thorough, accessible, and even-handed analysis of the issue I've found. The best part is its awesome map showing how and where the bill would effect zoning throughout the state. Sasha (the author of the project) also did a great job explaining some of the technical weaknesses of the law."), React.createElement("li", null, "The ", React.createElement("i", null, "New York Times"), " published a good piece titled", ' ', React.createElement("a", { href: "https://www.nytimes.com/2018/03/16/business/energy-environment/climate-density.html" }, "A Bold, Divisive Plan to Wean Californians From Cars"), ' ', "about the environmental impacts of California land use and how SB 827 would reduce energy dependence."), React.createElement("li", null, "For a depressing view of the impact of the housing shortage on commutes:", ' ', React.createElement("a", { href: "https://www.nytimes.com/2017/08/17/business/economy/san-francisco-commute.html" }, "A 2:15 Alarm, 2 Trains and a Bus Get Her to Work by 7 A.M.")), React.createElement("li", null, "Senator Scott Weiner answered common questions and concerns regarding the bill in a post", ' ', React.createElement("a", { href: "https://extranewsfeed.com/my-transit-density-bill-sb-827-answering-common-questions-and-debunking-misinformation-226eaa7e1653" }, "here"), "."), React.createElement("li", null, "Not everyone supports SB 827. Here is a Change.org petition begun by some critics of the bill, which includes a good overview of the case against SB 827:", ' ', React.createElement("a", { rel: "nofollow", href: "https://www.change.org/p/california-state-legislature-no-to-sb-827-sb-828-stop-top-down-planning-unsustainable-high-density-housing-growth" }, "NO to SB 827 & SB 828! Stop Top-Down Planning & Unsustainable High-Density Housing Growth!"), ' ', "As I've mentioned, I'm sympathetic to some of concerns but disagree with the conclusions.")), React.createElement("p", null, "If you have any questions, disagreements, or additions, please email me at ", React.createElement("a", { href: "mailto:devonzuegel@gmail.com" }, "devonzuegel@gmail.com"), "! I (obviously) love discussing this stuff, and with an issue of this complexity there's always more to learn."), React.createElement("p", null, "Also please note that", ' ', React.createElement("a", { href: "https://medium.com/@Scott_Wiener/sb-827-amendments-affordability-transit-lines-height-ellis-act-protections-more-fae09ee3f897" }, "amendments to the bill"), ' ', "were made in early April that make some of the specific details in the renders incorrect.")], src: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3307.1722373935318!2d-118.49340641711257!3d34.01378959309922!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80c2a4d2297fd73f%3A0xc3a966dc543f315c!2s4th+St+%26+Colorado+Ave%2C+Santa+Monica%2C+CA+90401%2C+USA!5e0!3m2!1sen!2snl!4v1523830606354", address: ['Downtown Santa Monica'], impacts: [['Number of units', '46-52'], ['Occupancy', '65-84']] }), React.createElement("br", null), React.createElement(BeforeAndAfter_1.BeforeAndAfter, { before: Render04Before, after: Render04After, percent: 65 }), React.createElement(PlaceInfo_1.PlaceInfo, { before: Render04Before_FullSize, after: Render04After_FullSize, emphasis: "Where do we go from here?", description: [React.createElement("p", null, "We're at an exciting inflection point. A pro-housing coalition has been building steam, and the movement includes grassroots groups, Governor Jerry Brown, legislators across the state, businesses of all sizes from every industry, and more. Legislation of this ambition would have been unthinkable just a few years ago, but now it's just a matter of time."), React.createElement("p", null, "If you'd like to get involved, the nonprofit", ' ', React.createElement("a", { href: "https://cayimby.org/take-action/find-local-yimbys/" }, "California YIMBY"), ' ', "has good resources and my inbox is", ' ', React.createElement("a", { href: "https://devonzuegel.com/page/contact" }, "always open"), "."), React.createElement("p", null, "Finally, if you'd like to make any changes to this site, feel free to", ' ', React.createElement("a", { href: "https://github.com/devonzuegel/sb827" }, "open a pull request"), ' ', "or let me know ", React.createElement("a", { href: "https://twitter.com/devonzuegel" }, "on Twitter"), "/", React.createElement("a", { href: "mailto:devonzuegel@gmail.com" }, "via email"), ".", ' ')], src: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2885.5818568385357!2d-118.15809709572208!3d34.11575252655809!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80c2c489826955cf%3A0xa56990f4bb1c5300!2sDiamond+Ave+%26+Mission+St%2C+South+Pasadena%2C+CA+91030%2C+USA!5e0!3m2!1sen!2snl!4v1523830433371", address: ['Diamond and Mission', 'South Pasadena'], impacts: [['Number of units', '46-52'], ['Occupancy', '65-84']] }), React.createElement("br", null), React.createElement("br", null), React.createElement("br", null), React.createElement(Footer_1.ThankYou, null));
	    };
	
	    return default_1;
	}(React.Component);
	
	exports.default = default_1;
	exports.pageQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-tsx-365a4c352ea3bc35886b.js